import { fetcher } from "helpers/fetcher";

import { TDeleteFileReq, TDeleteFileRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteTicketAttachment = async (payload: TDeleteFileReq) => {
  return await fetcher<TDeleteFileRes, any>(
    ENDPOINT.MANAGEMENT.DELETE_TICKET_ATTACHMENT,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
        [API_HEADER.VERSION]:
          ENDPOINT.MANAGEMENT.DELETE_TICKET_ATTACHMENT.version,
      },
      urlData: { idAttachment: payload.idAttachment },
    }
  );
};

export const mutationDeleteTicketAttachment = async (
  payload: TDeleteFileReq
) => {
  return (await deleteTicketAttachment(payload)).data.message;
};

mutationDeleteTicketAttachment._key = (payload: TDeleteFileReq) => [
  ENDPOINT.MANAGEMENT.DELETE_TICKET_ATTACHMENT.url,
  payload,
];
